import { z } from "zod"

export const airspaceBoundsSchema = z.object({
    minLat: z.number(),
    maxLat: z.number(),
    minLng: z.number(),
    maxLng: z.number(),
})

export const airspaceQuerySchema = z.object({
    simplificationTolerance: z.number(),
    minShapeArea: z.number(),
    excludeIds: z.array(z.string()),
    bounds: airspaceBoundsSchema,
})

export type AirspaceQuery = z.infer<typeof airspaceQuerySchema>
